import script from "./Web3WalletModal.vue?vue&type=script&setup=true&lang=js"
export * from "./Web3WalletModal.vue?vue&type=script&setup=true&lang=js"

import "./Web3WalletModal.vue?vue&type=style&index=0&id=18208393&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18208393"]])

export default __exports__